export function setLocalStore(key: string, value: any) {
  if (value === undefined) {
    localStorage.removeItem(key);
    return;
  }
  const serialized = JSON.stringify(value);
  if (serialized === undefined) {
    localStorage.removeItem(key);
    return;
  }
  localStorage.setItem(key, serialized);
}

export function getLocalStore(key: string) {
  const raw = localStorage.getItem(key);
  if (raw == null || raw === "" || raw === "undefined") {
    return {};
  }
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

export function removeLocalStore(key: string) {
  localStorage.removeItem(key);
}

export function clearLocalStore() {
  localStorage.clear();
}

export function setObjectInLocalStore(key: string, object: object) {
  if (object) {
    setLocalStore(key, object);
  }
}

export function getObjectFromLocalStore(key: string) {
  try {
    const objectString = getLocalStore(key);
    return objectString;
  } catch (e) {
    return {};
  }
}
